<script lang="ts" setup>
import { ref, watch, nextTick, onMounted } from 'vue'

const props = defineProps({
	isSelected: {
		type: Boolean,
		default: false,
	},
	isHoveredEnabled: {
		type: Boolean,
		default: false,
	},
	isOverlayShow: {
		type: Boolean,
		default: false,
	},
	isOverlayAutoFadeOut: {
		type: Boolean,
		default: true,
	},
})

const overlay = ref<HTMLElement>()
const scrollAnchor = ref<Element>()
const isScrollBottom = ref(false)
const observer = ref<IntersectionObserver>()
const hideOverlay = ref(false)
const emit = defineEmits([
	'overlay-cancel-click',
	'content-click',
	'overlay-click',
])

function closeOverlay() {
	// need to fixed later
	// props.isOverlayShow = false
	emit('overlay-cancel-click')
}

function observerOverlayScroll() {
	const callback = (
		entries: IntersectionObserverEntry[],
		observer: IntersectionObserver,
	) => {
		entries.forEach(entry => {
			if (entry.intersectionRatio === 1) {
				isScrollBottom.value = true
			} else {
				isScrollBottom.value = false
			}
		})
	}

	observer.value = new IntersectionObserver(callback, {
		root: overlay.value,
		threshold: [0, 1],
	})
}

watch(
	() => props.isOverlayShow,
	newValue => {
		if (newValue) {
			hideOverlay.value = true
			nextTick(() => {
				hideOverlay.value = false
				if (scrollAnchor.value) {
					observer?.value?.observe(scrollAnchor.value)
				}
			})
		} else {
			observer?.value?.disconnect()
		}
	},
)

onMounted(() => {
	observerOverlayScroll()
})
</script>

<template>
	<div
		class="bs-normal-card"
		:class="{
			'bs-normal-card--hoverable': isHoveredEnabled,
			'bs-normal-card--selected': isSelected,
		}"
	>
		<div class="bs-normal-card__content" @click="$emit('content-click')">
			<slot name="content"></slot>
		</div>
		<div
			ref="overlay"
			v-if="isOverlayShow"
			v-show="!hideOverlay"
			class="bs-normal-card__overlay"
			@click="$emit('overlay-click')"
		>
			<div class="bs-normal-card__overlay__content" ref="overlayScroll">
				<slot name="overlayContent"></slot>
				<div ref="scrollAnchor"></div>
			</div>
			<span
				class="bs-normal-card__overlay__cancel bs-normal-card__icon__cancel"
				@click.stop="closeOverlay()"
			></span>
			<div
				v-if="isOverlayAutoFadeOut"
				class="bs-normal-card__overlay__shadow"
				:class="{ 'bs-normal-card__overlay__shadow--hide': isScrollBottom }"
			></div>
		</div>
	</div>
</template>
